import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconMask1: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="mask, medical-mask, covid"><path d="M4.75 15.4947V5.75L12 3.75L19.25 5.75V15.4947C19.25 16.2622 18.8107 16.9621 18.1195 17.2958L12 20.25L5.8805 17.2958C5.18927 16.9621 4.75 16.2622 4.75 15.4947Z" stroke="currentColor" strokeWidth="1.5"/><path d="M9 9.75H15" stroke="currentColor" strokeWidth="1.5"/><path d="M9 13.75H15" stroke="currentColor" strokeWidth="1.5"/><path d="M19.5 8.25H22V12.75H19.5" stroke="currentColor" strokeWidth="1.5"/><path d="M4.5 8.25H2V12.75H4.5" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconMask1;
